module.exports = __webpack_public_path__ + "img/ic_bolt_black_24dp.f80c107e.png";